<script>
  import ClickOut from '../../../utils/directives/clickout'
  import MenuAdminSite from './menu/AdminSite'
  import MenuConfiguracoes from './menu/Configuracoes'
  import MenuPoliciaCivil from './menu/PoliciaCivil'
  import MenuEspiritoSanto from './menu/EspiritoSanto'
  import MenuBI from './menu/BI'
  import { mapState, mapGetters } from 'vuex'
  import ACL from '../../../domain/acl/tmp-acl'
  import MenuRelatorios from './menu/Relatorios'
  import MenuLeilao from './menu/Leilao'
  import MenuLogs from './menu/Logs'
  import {GRV_PREFEITURA, GRV_CAMPOS_DOS_GOYTACAZES} from '../../../domain/grv/helpers/tipos-grv'
  import MenuItem from './MenuItem'
  import MenuTitle from './MenuTitle'

export default {
    computed: {
      ...mapState({
        menuOpen: state => state.app.menuOpen
      }),
      ...mapGetters(['isLogged', 'currentUser']),
      ACL () {
        return ACL
      },
      podeAcessarGrvs () {
        return [
          this.ID_CONTRATO_DETRO,
          this.ID_CONTRATO_DETRAN_VILA_VELHA_ES,
          this.ID_CONTRATO_DETRAN_CACHOEIRO_ES,
          this.ID_CONTRATO_PREFEITURA,
          this.ID_CONTRATO_CAMPOS_DOS_GOYTACAZES
        ].some(id => ACL.checaAcessoContrato(id, this.currentUser.id))
      }
    },
    mounted () {
      this.popupItem = this.$el
    },
    data () {
      return {
        GRV_PREFEITURA,
        GRV_CAMPOS_DOS_GOYTACAZES,
        ID_CONTRATO_DETRO: 1,
        ID_CONTRATO_DETRAN_VILA_VELHA_ES: 3,
        ID_CONTRATO_DETRAN_CACHOEIRO_ES: 7,
        ID_CONTRATO_PREFEITURA: 8,
        ID_CONTRATO_CAMPOS_DOS_GOYTACAZES: 9
      }
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        if (this.menuOpen === true) {
          this.$store.commit('APP/SET_TOGGLE_MENU', false)
        }
      }
    },
    components: {
      MenuTitle,
      MenuItem,
      MenuRelatorios,
      MenuAdminSite,
      MenuBI,
      MenuConfiguracoes,
      MenuPoliciaCivil,
      MenuEspiritoSanto,
      MenuLeilao,
      MenuLogs
    },
    directives: {ClickOut}
  }
</script>

<template>
  <!-- TODO: Menu com 'app-aside-fixed' não funciona o hover -->
  <div id="aside" class="app-aside hidden-xs bg-black hidden-print " v-click-out="hide" @click="toggle"
       :class="{ 'off-screen': menuOpen }">
    <div class="aside-wrap">
      <div class="navi-wrap">
        <!-- nav -->
        <nav ui-nav class="navi clearfix">
          <ul class="nav">
            <li class="m-t">
              <router-link v-if="!ACL.check('coordES', currentUser.id)" to="/">
                <i class="fa fa-windows icon text-primary"></i>
                <span>Dashboard</span>
              </router-link>
            </li>
            <menu-title v-if="ACL.check('restrito_visitante', currentUser.id)">Remoção</menu-title>

            <menu-item
              :to="{ name: 'callcenter.main' }"
              label="Callcenter"
              icon="fa-headphones"
              icon-color-class="text-info"
              :show="ACL.check('restrito_visitante', currentUser.id)"
            ></menu-item>

            <menu-title>Apps</menu-title>

            <menu-item
              :to="{ name: 'arrematantes' }"
              label="Arrematantes"
              icon="fa-users"
              icon-color-class="text-info"
              :show="ACL.check('restrito_visitante', currentUser.id)"
            ></menu-item>

            <menu-item
              :to="{ name: 'comitentes' }"
              label="Comitentes"
              icon="fa-briefcase"
              icon-color-class="text-success"
              :show="ACL.check('restrito_visitante', currentUser.id)"
            ></menu-item>

            <menu-item
              :to="{ name: 'documentos' }"
              label="Documentos"
              icon="icon-docs"
              :show="ACL.check('restrito_visitante', currentUser.id)"
            ></menu-item>

            <!--<li>
              <router-link :to="{ name: 'edital' }">
                <i class="icon-docs icon"></i>
                <span>Editais</span>
              </router-link>
            </li>-->
            <MenuAdminSite v-if="ACL.check('restrito_visitante', currentUser.id)"/>
            <MenuConfiguracoes v-if="ACL.check('restrito_visitante', currentUser.id) && ACL.check('acesso_menu_configuracoes', currentUser.id)"/>
            <MenuLeilao v-if=" ACL.check('restrito_visitante', currentUser.id) && ACL.check('visualizar_leilao', currentUser.id)"/>

            <menu-title v-if="podeAcessarGrvs">GRV</menu-title>

            <MenuPoliciaCivil v-if="!ACL.check('coordES', currentUser.id) && ACL.checaAcessoContrato(ID_CONTRATO_DETRO, currentUser.id)"/>
            <MenuEspiritoSanto v-if="ACL.checaAcessoContrato(ID_CONTRATO_DETRAN_VILA_VELHA_ES, currentUser.id) || ACL.checaAcessoContrato(ID_CONTRATO_DETRAN_CACHOEIRO_ES, currentUser.id)" />

            <menu-item
              :to="{ name: 'grv' }"
              label="GRVs Detro-RJ"
              icon="fa-file-text-o"
              icon-color-class="text-info"
              :show="ACL.check('restrito_visitante', currentUser.id) && ACL.checaAcessoContrato(ID_CONTRATO_DETRO, currentUser.id)"
            ></menu-item>

            <menu-item
              :to="{ name: 'grv', query: {tipoGrv: GRV_PREFEITURA} }"
              label="GRVs Prefeitura Barra do Piraí"
              icon="fa-file-text-o"
              :show="ACL.check('restrito_visitante', currentUser.id) && ACL.checaAcessoContrato(ID_CONTRATO_PREFEITURA, currentUser.id)"
            ></menu-item>

            <menu-item
              :to="{ name: 'grv', query: {tipoGrv: GRV_CAMPOS_DOS_GOYTACAZES} }"
              label="GRVs Campos dos Goytacazes"
              icon="fa-file-text-o"
              icon-color-class="text-grey"
              :show="ACL.check('restrito_visitante', currentUser.id) && ACL.checaAcessoContrato(ID_CONTRATO_CAMPOS_DOS_GOYTACAZES, currentUser.id)"
            ></menu-item>

            <li class="line dk hidden-folded"></li>

            <menu-item
              :to="{ name: 'localizacao-veiculo' }"
              label="Localização de Veículo"
              icon="fa-anchor"
              icon-color-class="text-info"
              :show="ACL.check('acesso_menu_localizacao', currentUser.id) && (!ACL.check('coordES', currentUser.id))"
            ></menu-item>

            <menu-item
              :to="{ name: 'transferencia-patio' }"
              label="Transferência de Pátio"
              icon="fa-car"
              icon-color-class="text-info"
              :show="ACL.check('acesso_menu_transferencia', currentUser.id) && (!ACL.check('coordES', currentUser.id))"
            ></menu-item>

            <menu-item
              :to="{ name: 'cobranca' }"
              label="Cobranças"
              icon="fa-money"
              icon-color-class="text-success"
              :show="ACL.check('restrito_visitante', currentUser.id)"
            ></menu-item>

            <menu-item
              :to="{ name: 'relatorios-gerencial' }"
              label="Relatórios Gerenciais"
              icon="fa-file-excel-o"
              icon-color-class="text-success"
              :show="ACL.check('acesso_menu_relatorios_gerenciais', currentUser.id) && !ACL.check('coordES', currentUser.id)"
            ></menu-item>

            <MenuRelatorios v-if="!ACL.check('coordES', currentUser.id)"/>
            <MenuLogs v-if="ACL.check('restrito_visitante', currentUser.id) && (ACL.check('exibir_logs', currentUser.id) && !ACL.check('coordES', currentUser.id) || ACL.check('exibir_tasks', currentUser.id))"/>

            <li class="line dk hidden-folded"></li>
            <menu-title
              v-if="ACL.check('restrito_visitante', currentUser.id) && ACL.check('gerenciar_usuario_intranet', currentUser.id)"
            >Colaborativo</menu-title>

            <menu-item
              :to="{name: 'usuarios'}"
              label="Usuários"
              icon="icon-user"
              icon-color-class="text-success-lter"
              :show="ACL.check('restrito_visitante', currentUser.id) && ACL.check('gerenciar_usuario_intranet', currentUser.id)"
            ></menu-item>

            <menu-item
              :to="{name: 'usuarios', query: { somenteConsultaReboque: true }}"
              label="Usuários Consulta Reboque"
              icon="icon-user"
              icon-color-class="text-info"
              :show="ACL.check('restrito_visitante', currentUser.id) && ACL.check('gerenciar_usuario_intranet', currentUser.id)"
            ></menu-item>

            <menu-item
              :to="{name: 'historico.alteracoes'}"
              label="Histórico de alterações sistema"
              icon="fa-history"
              icon-color-class="text-danger-dker"
              :show="ACL.check('restrito_visitante', currentUser.id) && ACL.check('visualizar_log_alteracoes_usuarios', currentUser.id)"
            ></menu-item>

            <menu-title v-if="ACL.check('restrito_visitante', currentUser.id)">Estatísticas</menu-title>
            <MenuBI v-if="ACL.check('restrito_visitante', currentUser.id)"/>

            <menu-item
              :to="{name: 'relatorios-basico'}"
              label="Relatórios Básicos"
              icon="icon-list"
              :show="ACL.check('restrito_visitante', currentUser.id)"
            ></menu-item>

            <menu-title v-if="ACL.check('restrito_visitante', currentUser.id)">Comunicação e Marketing</menu-title>

            <menu-item
              :to="{ name: 'contatos' }"
              label="Contatos"
              icon="glyphicon-envelope"
              icon-color-class="text-info-lter"
              icon-type="glyphicon"
              :show="ACL.check('restrito_visitante', currentUser.id)"
            ></menu-item>

            <!--<li v-if="ACL.check('rh', currentUser.id)" ui-sref-active="active">
              <router-link :to="{ name: 'trabalhe.conosco.index' }">
                <i class="fa fa-briefcase icon text-info-lter"></i>
                <span class="font-bold ng-scope">Trabalhe Conosco</span>
              </router-link>
            </li>-->

            <li v-if="ACL.check('restrito_visitante', currentUser.id)">
              <a href="https://m.rebocarleiloes.com.br" target="_blank">
                <i class="fa fa-location-arrow icon text-primary"></i>
                <span>Automação</span>
              </a>
            </li>
            <li v-if="ACL.check('restrito_visitante', currentUser.id)">
              <a @click="$parent.toggleChat()" target="_blank">
                <i class="icon-bubbles icon text-info"></i>
                <span>Chat</span>
              </a>
            </li>
            <!--<li><a href="javascript://"> <i class="glyphicon glyphicon-stats icon"></i> <span>Metas</span> </a></li>-->
            <!--<li><a href="javascript://"> <i class="icon-question icon"></i> <span>Documentos</span> </a></li>-->
          </ul>
        </nav>
        <!-- nav -->

        <!-- menu footer -->
        <div class="wrapper m-t hidden">
          <!-- Metas do mês -->
          <div class="text-center-folded"><span class="pull-right pull-none-folded">50%</span> <span
            class="hidden-folded">Metas do mês</span></div>
          <div class="progress progress-xxs m-t-sm dk">
            <div class="progress-bar progress-bar-info" style="width: 50%;"></div>
          </div>
          <!-- Metas do dia -->
          <div class="text-center-folded"><span class="pull-right pull-none-folded">50%</span> <span
            class="hidden-folded">Metas do dia</span></div>
          <div class="progress progress-xxs m-t-sm dk">
            <div class="progress-bar progress-bar-success" style="width: 50%;"></div>
          </div>
          <!-- Leitura de avisos -->
          <div class="text-center-folded"><span class="pull-right pull-none-folded">50%</span> <span
            class="hidden-folded">Leitura dos avisos</span></div>
          <div class="progress progress-xxs m-t-sm dk">
            <div class="progress-bar progress-bar-danger" style="width: 50%;"></div>
          </div>
        </div>
        <!-- / menu footer -->
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// Menu.vue?f0308100